export function debounce(fn, delay) {
    // 记录上一次的延时器
    var timer = null;
    var delay = delay || 200;
    return function() {
      var args = arguments;
      var that = this;
      // 清除上一次延时器
      clearTimeout(timer)
      timer = setTimeout(function() {
          fn.apply(that,args)
      }, delay);
    }
  }


  export function throttle(fn, delay) {
    // 记录上一次的延时器
    var delay = delay || 200;
    var prev = null
    return function() {
      var args = arguments;
      var that = this;
      var now = Date.now()
      if (prev && (now - prev) < delay) {
        return
      }
      fn.apply(that,args)
      prev = now
    }
  }
